import axios from 'axios'
import { Message } from 'element-ui';
import { getLocalStorage, removeLocalStorage } from './localStorage';
import { host } from './host';
// 创建axios实例
const service = axios.create({
  baseURL: host, // api的base_url
  timeout: 20000,                  // 请求超时时间
  withCredentials: true,
  validateStatus: function(status) {
    return [200, 201, 204, 422, 401, 400, 404, 429, 403].indexOf(status) !== -1 // 默认的
  }
})

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (getLocalStorage()) {
    config.headers['Token'] = getLocalStorage(); // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code && parseInt(response.data.code) !== 0) {
      if (parseInt(response.data.code) === 1010 || parseInt(response.data.code) === 1004) {
        Message({
          message: response.data.message,
          type: 'error',
          duration: 5 * 1000
        })
        removeLocalStorage()
        window.location.href = window.location.origin + '/login'
      } else {
        Message({
          message: response.data.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return response
  },

  error => {
    console.log(error);// for debug
    var str = error + ""
    if (str.search('timeout') !== -1) {
      Message({
        message: '网络请求超时',
        type: 'error',
        duration: 5 * 1000
      });
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
)

export default service;
